import CustomCard from "@/components/CustomCard";
import Filter from "@/components/filter";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import {
  getAllActiveUsers,
  getAllBlockedUsers,
  getAllUserCount,
  getAllVerifiedUsers,
  getTotalTransactions,
  getTotalTransactionsCount,
  getTransactionsRate,
} from "@/services/Home.service";
import { Storage } from "@/services/storage-services";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";

const Home = () => {
  const queryClient = useQueryClient();
  const [currencySymbol, setCurrencySymbol] = useState("USD");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [filterText, setFilterText] = useState("All times");

  const userCountRes = useQuery({
    queryKey: ["userCount"],
    queryFn: async () => await getAllUserCount({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });
  const res = useQuery({
    queryKey: ["verifiedUsers"],
    queryFn: async () =>
      await getAllVerifiedUsers({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });

  const active = useQuery({
    queryKey: ["activeUsers"],
    queryFn: async () =>
      await getAllActiveUsers({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });
  const blocked = useQuery({
    queryKey: ["blockedUsers"],
    queryFn: async () =>
      await getAllBlockedUsers({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });
  const transaction = useQuery({
    queryKey: ["transactionSum"],
    queryFn: async () =>
      await getTotalTransactions({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });

  const transactionCount = useQuery({
    queryKey: ["transactionCount"],
    queryFn: async () =>
      await getTotalTransactionsCount({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });

  const rate = useQuery({
    queryKey: ["rate"],
    queryFn: async () =>
      await getTransactionsRate({ from: dateFrom, to: dateTo }),
    refetchOnMount: "always",
  });

  // const handleSelectFromChange = (dateString) => {
  //   setFilter({ ...filter, from: dateString });
  // };
  // const handleSelectToChange = (dateString) => {
  //   setFilter({ ...filter, to: dateString });
  // };

  const apply = () => {
    queryClient.invalidateQueries({ queryKey: ["userCount"] });
    queryClient.invalidateQueries({ queryKey: ["verifiedUsers"] });
    queryClient.invalidateQueries({ queryKey: ["activeUsers"] });
    queryClient.invalidateQueries({ queryKey: ["blockedUsers"] });
    queryClient.invalidateQueries({ queryKey: ["transactionSum"] });
    queryClient.invalidateQueries({ queryKey: ["transactionCount"] });
    queryClient.invalidateQueries({ queryKey: ["rate"] });
  };

  useEffect(() => {
    if (filterText === "All times") {
      queryClient.refetchQueries();
    }
  }, [filterText]);
  const d = Storage.getItem("selectedMerchant")?.businessName?.substring(0, 1);
  const merchant = Storage.getItem("selectedMerchant");

  return (
    <div className="grid p-6 gap-[40px]">
      <div className="flex items-center gap-4 justify-between">
        <div className="flex gap-4">
          {merchant === null ? (
            <Skeleton className="w-14 h-14" />
          ) : (
            <Avatar className="w-14 h-14">
              <AvatarImage />
              <AvatarFallback>{d}</AvatarFallback>
            </Avatar>
          )}
          <div className="flex-col gap-2">
            {merchant === null ? (
              <Skeleton className="w-full h-4" />
            ) : (
              <p className="text-2xl text-primary-3">
                Hi,{" "}
                <span className="font-semibold">{merchant?.businessName}</span>
              </p>
            )}
            {merchant === null ? (
              <Skeleton className="w-full h-4" />
            ) : (
              <p className="flex gap-2 text-base capitalize text-gray">
                <BsFillPatchCheckFill className="w-5 h-5 text-green" />{" "}
                {merchant?.roleId?.split("-")[1]}
              </p>
            )}
          </div>
        </div>
        <Filter
          selected={filterText}
          setSelected={setFilterText}
          selectDateFromChange={setDateFrom}
          selectDateToChange={setDateTo}
          refetch={apply}
        />
      </div>

      <div className="grid gap-6">
        <div className="grid gap-6 lg:grid-cols-3">
          <CustomCard
            title="Total Transacted Volume"
            mainTitle={transaction?.data?.data?.data?.result?.toLocaleString(
              "en-US",
              {
                style: "currency",
                currency: "USD",
              }
            )}
            text="16"
            isLoading={transaction?.isFetching}
            date={dateTo}
          />
          <CustomCard
            title="Total Customers"
            mainTitle={userCountRes?.data?.data?.data?.count}
            text="16"
            isLoading={userCountRes?.isFetching}
            date={dateTo}
          />
          <CustomCard
            title="Exchange rate"
            mainTitle={`NGN ${rate?.data?.data?.data?.result}/$`}
            isLoading={rate?.isFetching}
            text=""
            date=""
          />
        </div>
        <div className="grid gap-6 lg:grid-cols-4">
          <CustomCard
            title="Transaction Count"
            mainTitle={transactionCount?.data?.data?.data?.result}
            isLoading={transactionCount?.isFetching}
            text="16"
            date={dateTo}
          />
          <CustomCard
            title="Verified customers"
            mainTitle={res?.data?.data?.data?.count}
            isLoading={res?.isFetching}
            text="16"
            date={dateTo}
          />
          <CustomCard
            title="Active customers"
            mainTitle={active?.data?.data?.data?.count}
            isLoading={active?.isFetching}
            text="16"
            date={dateTo}
          />
          <CustomCard
            title="Suspended customers"
            mainTitle={blocked?.data?.data?.data?.count}
            isLoading={blocked?.isFetching}
            text="16"
            date={dateTo}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
